var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.6104 0.821685L13.3479 6.75661C13.4935 7.07242 13.7928 7.28986 14.1382 7.33081L20.6286 8.10035L15.8301 12.5379C15.5747 12.774 15.4604 13.1258 15.5282 13.4669L16.802 19.8775L11.0988 16.6851C10.7953 16.5152 10.4254 16.5152 10.1219 16.6851L4.41875 19.8775L5.69251 13.4669C5.76029 13.1258 5.64598 12.774 5.39064 12.5379L0.592128 8.10035L7.08252 7.33081C7.42788 7.28986 7.72717 7.07242 7.87284 6.75661L10.6104 0.821685Z","stroke":"#042660","fill":"currentColor"}));
}

Star.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none","variant":"light","className":"sc-cTjmhe eldfBJ"};

module.exports = Star;

Star.default = Star;
